import styled from "styled-components";

export const CallCardRow = styled.div`
    display: flex;
    justify-content: ${p => p.$isMine ? "flex-end" : "flex-start"};
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.9375rem;
    margin-bottom: 0.4375rem;
`;

export const CallCard = styled.div`
    display: grid;
    grid-template-columns: 2rem minmax(0, 1fr) auto;
    gap: 0.625rem;
    align-items: center;
    width: min(19rem, 82%);
    border: 1px solid ${p => p.$cancelled ? "rgba(5, 5, 5, 0.72)" : p.$missed ? "#C7C7C7" : "#AEB8E8"};
    border-radius: ${p => p.$isMine ? "1rem 1rem 0 1rem" : "1rem 1rem 1rem 0"};
    background: ${p => p.$cancelled ? "rgba(5, 5, 5, 0.08)" : p.$missed ? "#FFFFFF" : "#EFF2FF"};
    color: #050505;
    box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0.12);
    padding: 0.75rem;
`;

export const CallCardIcon = styled.img`
    width: 2rem;
    height: 2rem;
    background: transparent;
    display: block;
    object-fit: contain;
    animation: none;
    transform: none;
    filter: none;
`;

export const CallCardContent = styled.div`
    min-width: 0;
    font-family: Manrope, Helvetica, sans-serif;
`;

export const CallCardTitle = styled.div`
    color: ${p => p.$cancelled || p.$missed ? "#050505" : "#001399"};
    font-size: 0.8125rem;
    font-weight: 700;
    line-height: 1.35;
`;

export const CallCardText = styled.div`
    color: #050505;
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1.3;
`;

export const CallAgainButton = styled.button`
    width: 5.75rem;
    min-height: 1.875rem;
    padding: 0 0.75rem;
    border: 0;
    border-radius: 0.5rem;
    background: #001399;
    color: #FFFFFF;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
`;

export const CallCardActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    align-items: flex-end;
`;

export const CallNotesToggleButton = styled.button`
    width: 5.75rem;
    min-height: 1.875rem;
    padding: 0 0.75rem;
    border: 1px solid #AEB8E8;
    border-radius: 0.5rem;
    background: #FFFFFF;
    color: #001399;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
`;

export const CallCardNotes = styled.div`
    grid-column: 1 / -1;
    border-top: 1px solid rgba(0, 19, 153, 0.16);
    margin-top: 0.125rem;
    padding-top: 0.625rem;
    max-height: 8.5rem;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-right: 0.25rem;
`;

export const CallNotesModalList = styled.div`
    max-height: min(32rem, 60vh);
    overflow-y: auto;
    padding-right: 0.25rem;
`;

export const CallCardNotesTitle = styled.div`
    color: #001399;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 800;
    margin-bottom: 0.5rem;
`;

export const CallCardNote = styled.div`
    border-radius: 0.5rem;
    background: rgba(255, 255, 255, 0.72);
    padding: 0.5rem 0.625rem;

    & + & {
        margin-top: 0.375rem;
    }
`;

export const CallCardNoteHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    color: #001399;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.6875rem;
    font-weight: 800;
    line-height: 1.3;
`;

export const CallCardNoteTime = styled.span`
    color: #555B73;
    font-weight: 600;
    white-space: nowrap;
`;

export const CallCardNoteBody = styled.div`
    color: #050505;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.4;
    margin-top: 0.25rem;
    white-space: pre-wrap;
    word-break: break-word;
`;

export const CenteredCallNotice = styled.div`
    width: 100%;
    text-align: center;
`;

export const CenteredCallNoticeText = styled.div`
    font-size: 12px;
    color: gray;
    font-weight: 400;
    padding: 3px 0;
`;

export const CenteredCallNotesButton = styled.button`
    border: 0;
    background: transparent;
    color: #001399;
    cursor: pointer;
    font: inherit;
    padding: 0;
    text-decoration: underline;
`;

export const CenteredCallNotes = styled.div`
    width: min(19rem, 82%);
    max-height: 8.5rem;
    overflow-y: auto;
    overscroll-behavior: contain;
    margin: 0.375rem auto 0.625rem;
    padding: 0.625rem;
    border: 1px solid #AEB8E8;
    border-radius: 0.75rem;
    background: #EFF2FF;
    box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0.12);
    text-align: left;
`;
